/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Try_EmptyInputs */

const en_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results for that input. Check the value is correct (handles omit the leading @). The account or item may be private, removed, or not exist.`)
};

const zh_hans1_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个输入没有结果。请检查值是否正确（用户名不带开头的 @）。该账号或内容可能是私密的、已被删除或不存在。`)
};

const pt_br2_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado para essa entrada. Confira se o valor está correto (handles vão sem o @ inicial). A conta ou o item pode ser privado, ter sido removido ou não existir.`)
};

const es_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay resultados para esa entrada. Verifica que el valor sea correcto (los nombres de usuario van sin la @ inicial). La cuenta o el elemento puede ser privado, haber sido eliminado o no existir.`)
};

const fr_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat pour cette entrée. Vérifiez que la valeur est correcte (les identifiants s’écrivent sans le @ initial). Le compte ou l’élément est peut-être privé, supprimé ou inexistant.`)
};

const de_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse für diese Eingabe. Prüfe, ob der Wert stimmt (bei Handles entfällt das führende @). Das Konto oder der Eintrag kann privat, entfernt oder nicht vorhanden sein.`)
};

const ru_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По этому вводу нет результатов. Проверьте значение (в именах пользователей нет первого @). Аккаунт или объект может быть закрытым, удалённым или не существовать.`)
};

const it_endpoint_try_empty = /** @type {(inputs: Endpoint_Try_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato per questo input. Controlla che il valore sia corretto (gli handle omettono la @ iniziale). L'account o l'elemento potrebbe essere privato, rimosso o inesistente.`)
};

/**
* | output |
* | --- |
* | "No results for that input. Check the value is correct (handles omit the leading @). The account or item may be private, removed, or not exist." |
*
* @param {Endpoint_Try_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_try_empty = /** @type {((inputs?: Endpoint_Try_EmptyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Try_EmptyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_try_empty(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_try_empty(inputs)
	if (locale === "es") return es_endpoint_try_empty(inputs)
	if (locale === "fr") return fr_endpoint_try_empty(inputs)
	if (locale === "de") return de_endpoint_try_empty(inputs)
	if (locale === "ru") return ru_endpoint_try_empty(inputs)
	if (locale === "it") return it_endpoint_try_empty(inputs)
	return en_endpoint_try_empty(inputs)
});